function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "1bb150a8-47e8-48a0-8586-3a0b005e9061",
  x1: 762.35,
  y1: 767.37,
  x2: 762.35,
  y2: 290.82,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0.01,
  stopColor: "gray",
  stopOpacity: 0.25
}), React.createElement("stop", {
  offset: 0.54,
  stopColor: "gray",
  stopOpacity: 0.12
}), React.createElement("stop", {
  offset: 1,
  stopColor: "gray",
  stopOpacity: 0.1
})), React.createElement("linearGradient", {
  id: "81ddbcf2-2292-4b47-939f-09c11d0fad8e",
  x1: 436.09,
  y1: 608.57,
  x2: 436.09,
  y2: 132.63,
  xlinkHref: "#1bb150a8-47e8-48a0-8586-3a0b005e9061"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "chat");

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M998.41,290.82H566.95c-42.38,0-76.74,34.69-76.74,77.48V636.48a36.26,36.26,0,0,0,36.09,36.44h274c9.12,31.56,32,75.06,89.64,94.45l-16.27-94.45H998.41a36.26,36.26,0,0,0,36.09-36.44V327.26A36.26,36.26,0,0,0,998.41,290.82Z",
  transform: "translate(-165.5 -132.63)",
  fill: "url(#1bb150a8-47e8-48a0-8586-3a0b005e9061)"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M991.15,299.86H572.35a74.49,74.49,0,0,0-74.49,74.49V632.17a35,35,0,0,0,35,35H798.83c8.85,30.34,31.09,72.16,87,90.8L870,667.2h121.1a35,35,0,0,0,35-35V334.89A35,35,0,0,0,991.15,299.86Z",
  transform: "translate(-165.5 -132.63)",
  fill: "#fafafa"
});

var _ref6 =
/*#__PURE__*/
React.createElement("rect", {
  x: 500.77,
  y: 234.16,
  width: 216.47,
  height: 27.06,
  fill: "#e0e0e0"
});

var _ref7 =
/*#__PURE__*/
React.createElement("rect", {
  x: 634.84,
  y: 284.12,
  width: 81.18,
  height: 27.06,
  fill: "#e0e0e0"
});

var _ref8 =
/*#__PURE__*/
React.createElement("rect", {
  x: 554.7,
  y: 334.07,
  width: 160.08,
  height: 27.06,
  fill: "#e0e0e0"
});

var _ref9 =
/*#__PURE__*/
React.createElement("rect", {
  x: 517.24,
  y: 384.03,
  width: 196.32,
  height: 27.06,
  fill: "#e0e0e0"
});

var _ref10 =
/*#__PURE__*/
React.createElement("rect", {
  x: 608.82,
  y: 433.98,
  width: 103.51,
  height: 27.06,
  fill: "#e0e0e0"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M201.38,132.63H670.79c19.82,0,35.88,16.29,35.88,36.39V477.85c0,20.1-16.06,36.39-35.88,36.39H398.38c-9.07,31.52-31.85,75-89.13,94.33l16.18-94.33h-124c-19.82,0-35.88-16.29-35.88-36.39V169C165.5,148.92,181.56,132.63,201.38,132.63Z",
  transform: "translate(-165.5 -132.63)",
  fill: "url(#81ddbcf2-2292-4b47-939f-09c11d0fad8e)"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M206.77,142.1H665a35,35,0,0,1,35,35V474.41a35,35,0,0,1-35,35H399.09c-8.85,30.34-31.09,72.16-87,90.8l15.79-90.8H206.77a35,35,0,0,1-35-35V177.13A35,35,0,0,1,206.77,142.1Z",
  transform: "translate(-165.5 -132.63)",
  fill: "#fff"
});

var _ref13 =
/*#__PURE__*/
React.createElement("rect", {
  x: 162.16,
  y: 66.61,
  width: 216.47,
  height: 27.06,
  fill: "#1f85ff"
});

var _ref14 =
/*#__PURE__*/
React.createElement("rect", {
  x: 163.39,
  y: 116.56,
  width: 81.18,
  height: 27.06,
  fill: "#1f85ff"
});

var _ref15 =
/*#__PURE__*/
React.createElement("rect", {
  x: 164.62,
  y: 166.51,
  width: 160.08,
  height: 27.06,
  fill: "#1f85ff"
});

var _ref16 =
/*#__PURE__*/
React.createElement("rect", {
  x: 165.85,
  y: 216.47,
  width: 196.32,
  height: 27.06,
  fill: "#1f85ff"
});

var _ref17 =
/*#__PURE__*/
React.createElement("rect", {
  x: 167.08,
  y: 266.42,
  width: 103.51,
  height: 27.06,
  fill: "#1f85ff"
});

var SvgMessage = function SvgMessage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "41468acd-cd3b-42a6-b6d6-962a1482835f",
    "data-name": "Layer 1",
    width: 90,
    height: 90,
    viewBox: "0 0 869 634.74",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? React.createElement("title", null, title) : null, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMessage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/message.d4e06d09.svg";
export { ForwardRef as ReactComponent };